import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Flame, Sparkles, ArrowLeft, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import Reveal from "./Reveal";
import { Skel } from "./Skeleton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CulinarySection() {
  const { lang, t } = useApp();
  const [dishes, setDishes] = useState(null);
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

  useEffect(() => {
    axios.get(`${API}/culinary`).then((r) => setDishes(r.data.slice(0, 3))).catch(() => setDishes([]));
  }, []);

  return (
    <section className="section culinary-section" id="culinary" data-testid="culinary-section">
      <Reveal>
        <div className="section-head">
          <span className="section-tag">{t("culinary.tag")}</span>
          <h2 className="section-title">{t("culinary.title")}</h2>
          <p className="section-sub">{t("culinary.sub")}</p>
        </div>
      </Reveal>
      <div className="culinary-grid culinary-grid-3">
        {dishes === null && [0, 1, 2].map((i) => <Skel key={i} h={420} r={18} />)}
        {(dishes || []).map((dish, i) => (
          <Reveal key={dish.slug} delay={i * 140}>
            <Link to={`/culinary/${dish.slug}`} className="variety-card-link" data-testid={`culinary-link-${dish.slug}`}>
              <article className="culinary-card glass-card" data-testid={`culinary-card-${dish.slug}`}>
                <div className="culinary-img-wrap">
                  <img src={dish.image_traditional} alt={dish[`name_${lang}`]} className="culinary-img" loading="lazy" />
                  <h3 className="culinary-name">
                    {dish.name_ar} <span>{dish.name_en}</span>
                  </h3>
                </div>
                <div className="culinary-body">
                  <div className="story-block">
                    <span className="story-label"><Flame size={14} />{t("culinary.traditional")}</span>
                    <div className="rich rich-sm" dangerouslySetInnerHTML={{ __html: dish[`description_${lang}`] }} />
                  </div>
                  <div className="story-divider" />
                  <div className="story-block">
                    <span className="story-label modern"><Sparkles size={14} />{t("culinary.modern")}</span>
                    <p><strong>{dish[`modern_name_${lang}`]}</strong></p>
                  </div>
                  <span className="content-card-cta">{t("content.readMore")} <Arrow size={14} /></span>
                </div>
              </article>
            </Link>
          </Reveal>
        ))}
      </div>
      <div className="section-more">
        <Link to="/culinary" className="btn-lux-ghost" data-testid="culinary-all-link">{t("culinary.all")}</Link>
      </div>
    </section>
  );
}
